module.exports = __webpack_public_path__ + "img/box6-19.139fed8c.png";